import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
// import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
// import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
// import CustomButton from '../../../Components/CustomButton/CustomButton'
import CustomButton from '../../../../../../Components/CustomButton/CustomButton'

import ComboBox from '../../../../../../Components/ComboBox'
import { Input } from '../../../../../../Components/Input'
import { useForm, Controller } from 'react-hook-form'
import { makeGetRequest, makePostRequest, makePutRequest } from '../../../../../../utils/api'
import urls from '../../../../../../utils/urls'
import { Box, TextField, Autocomplete } from '@mui/material'
import { currentDate, convertToMuiDate } from '../../../../../../utils/helpers'
import { useParams, useNavigate } from 'react-router-dom'

// import EditIcon from '@mui/icons-material/Edit'
// import ButtonGroup from '@mui/material/ButtonGroup'
// import Tooltip from '@mui/material/Tooltip'
// import { styled } from '@mui/material/styles'
// import UploadFileIcon from '@mui/icons-material/UploadFile'
// import Link from '@mui/material/Link'

// import Stack from '@mui/material/Stack'

export default function EditPlanFinancementOperationForm({
  setOperations,
  params,
  operations,
  setSelected,
}) {
  const [open, setOpen] = useState(false)
  const [selectedCreditor, setSelectedCreditor] = useState({})
  let id = ''
  // const { objid } = useParams()
  const [contacts, setContacts] = useState([])
  const [financier, setFinancier] = useState([])
  const [typeObject, setTypeObject] = useState(0)

  // const log =  () =>{
  //   setValue( 'vehicleType', { label: `${params[0].vehicletypes.vehicletype}`, id: params[0].vehicletypes.id } )

  // }

  useEffect(() => {
    // fetchFinancementDetail()
    // fetchOperations()
    // fetchAllFinanciers()
  }, [])

  const fetchAllContacts = async (cat) => {
    const url = urls.getAllContacts
    const { data, status } = await makeGetRequest(url + '?Category=' + cat, {}, true)
    if (status === 200) {
      const filterContacts = []
      data.forEach((v) => {
        filterContacts.push({ label: `${v.Nom}`, id: v.id })
      })
      setContacts([...filterContacts])
    }
  }

  const fetchAllFinanciers = async () => {
    const url = urls.getAllFinanciers
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterContacts = []
      data.forEach((v) => {
        filterContacts.push({ label: `${v.Nom}`, id: v.id })
      })
      setFinancier([...filterContacts])
    }
  }

  const getIdFromOperations = () => {
    if (operations.results) {
      id = operations.results[0].finciments.id
    }
  }
  const handleClickOpen = () => {
    setOpen(true)
    getIdFromOperations()
    fetchFinancementDetail()
  }

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      // id: '',
      // ImmoObjectID: objid,
      BeginDate: currentDate(),
      TotalLoans: '',
      // Creditor: '',
      // Contact: '',
      // Financier: '',
      YearsDuration: '',
    },
  })

  const fetchFinancementDetail = async () => {
    const response = await makeGetRequest(urls.curdImmoFinancement + id, {}, true)
    if (response.status === 200) {
      // reset({...response.data,BeginDate:convertToMuiDate(response.data.BeginDate)})
      // let cat = response.data.Creditor
      // if(cat==='Famille'||cat==='Amis'){
      //   fetchAllContacts(cat)
      // }
      setValue('id', response.data.id)
      setValue(
        'BeginDate',
        response.data.BeginDate ? convertToMuiDate(response.data.BeginDate) : '',
      )
      setValue('TotalLoans', response.data.TotalLoans)
      setValue('Creditor', response.data.Creditor)
      // setSelectedCreditor(typeCreditor.filter((v) => v.label === response.data.Creditor)[0])
      // setValue('Contact',response.data.Contact)
      setValue('YearsDuration', response.data.YearsDuration)

      // setVehicule(response.data)
      // setRestToPay(response.data.RestToPay);
    }
  }
  const typeCreditor = [
    { label: 'Institutions_financiere', id: 1, value: 'Institutions_financiere' },
    { label: 'Famille', id: 2, value: 'Famille' },
    { label: 'Amis', id: 3, value: 'Amis' },
  ]

  const handleClose = () => {
    setOpen(false)
    reset()
    setSelected(false)
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }

    const response = await makePutRequest(
      urls.curdImmoFinancement + `${data.id}/`,
      payload,
      {},
      true,
    )

    if (response.status === 200) {
      let url = `${urls.curdPlanImmoFinancementViewDashboard}`
      const response = await makeGetRequest(url + '?ObjectID=' + data.id, {}, true)
      if (response.status === 200) {
        setOperations({ ...response.data })
        handleClose()
      }
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>Modifier plan de financement</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>Éditer financement</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="BeginDate"
              label="Begin Date"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="TotalLoans"
              label="Total Loans"
            />
            {/* <Controller
              name={'Creditor'}
              control={control}
              // defaultValue={''}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Autocomplete
                  disablePortal
                  sx={{ marginTop: '7px' }}
                  options={typeCreditor}
                  getOptionLabel={(option) =>
                    option?.label ?? typeCreditor.find(({ label }) => label === option)?.label ?? ''
                  }
                  isOptionEqualToValue={(option, value) => option.label === value.label}
                  {...field}
                  renderInput={(params) => (
                    <TextField required {...params} size="small" label="Creditor" />
                  )}
                  onChange={(_event, data) => {
                    
                    setTypeObject(data?.id)
                    field.onChange(data?.label || '')
                  }}
                />
              )}
            />
             {typeObject===1 && (
                <Controller
                  name={'Financier'}
                  control={control}
                  // defaultValue={'Maison'}
                  rules={{
                    required: true,
                  }}
                  render={({ field }) => (
                    <Autocomplete
                      disablePortal
                      sx={{ marginTop: '7px' }}
                      options={financier}
                      getOptionLabel={(option) =>
                        option?.label ?? financier.find(({ id }) => id === option)?.label ?? ''
                      }
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      {...field}
                      renderInput={(params) => (
                        <TextField required {...params} size="small" label="Financier" />
                      )}
                      onChange={(_event, data) => field.onChange(data?.id || '')}
                    />
                  )}
                />
              )}
              {(typeObject===2 || typeObject===3 ) && (

              // <Input
              //   control={control}
              //   inputProps={{
              //     variant: 'outlined',
              //     type: 'text',
              //     required: true,
              //     size: 'small',
              //   }}
              //   rules={{ required: true }}
              //   name='Contact'
              //   label='Contact'
              // />
              <Controller
                name={'Contact'}
                control={control}
                // defaultValue={'Maison'}
                rules={{
                  required: true,
                }}
                render={({ field }) => (
                  <Autocomplete
                    disablePortal
                    sx={{ marginTop: '7px' }}
                    options={contacts}
                    getOptionLabel={(option) =>
                      option?.label ?? contacts.find(({ id }) => id === option)?.label ?? ''
                    }
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    {...field}
                    renderInput={(params) => (
                      <TextField required {...params} size="small" label="Contact" />
                    )}
                    onChange={(_event, data) => field.onChange(data?.id || '')}
                  />
                )}
              />
              )} */}

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="YearsDuration"
              label="Years Duration"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
